import type { State } from '../../reducers/types';
import { getPersisted } from '../common';

export const getRowListRef = (state: State) => getPersisted(state).rowListRef;
